import request from '@/utils/request'

// 短剧列表
export function materialList(params) {
  return request({
    url: '/dxj/material/miniseries_list',
    method: 'get',
    params
  })
}
// 短剧素材列表
export function materialInfoList(params) {
  return request({
    url: '/dxj/material/list',
    method: 'get',
    params
  })
}

// 小说素材列表
export function NovelInfoList(params) {
  return request({
    url: '/dxj/material/novel_list',
    method: 'get',
    params
  })
}

// 小说素材导出
export function exportNovel(params) {
  return request({
    url: '/dxj/material/export_novel_material',
    method: 'get',
    params
  })
}

// 素材详情
export function materialInfo(params) {
  return request({
    url: '/dxj/material/novel_material_detail',
    method: 'get',
    params
  })
}

// 查询素材的信息(如果没有素材 在调用这个)
export function adxrclickpreview(data = {}) {
  return request({
    url: '/adx/material/click_preview',
    method: 'post',
    data
  })
}

